import { render } from "./ReposicionRuleUbicacionModal.vue?vue&type=template&id=1b5633f8"
import script from "./ReposicionRuleUbicacionModal.vue?vue&type=script&lang=js"
export * from "./ReposicionRuleUbicacionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__